import { useParams } from 'react-router-dom';

import { FormBuilder as FormBuilderCanvas } from '@/formBuilder';
import useBlueprint from '@/hooks/useBlueprint';

const FormBuilder = () => {
  const { blueprintId } = useParams<{ blueprintId: string }>();
  const { data, isPending, isError } = useBlueprint(blueprintId);
  const blueprint = data?.data;

  if (isPending) {
    return (
      <div className="p-16 text-uniform-gray-500 dark:text-uniform-gray-400">Loading form…</div>
    );
  }

  if (isError) {
    return (
      <div className="p-16 text-red-500 dark:text-red-400">
        Couldn&apos;t load this form. Please try again.
      </div>
    );
  }

  if (!blueprint) {
    return (
      <div className="p-16 text-uniform-gray-500 dark:text-uniform-gray-400">
        Blueprint not found.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-uniform-gray-100 p-8 dark:bg-uniform-gray-900">
      <FormBuilderCanvas
        blueprintId={blueprint.id}
        blueprintName={blueprint.title || blueprint.name}
        initialSchema={blueprint.form_schema}
      />
    </div>
  );
};

export default FormBuilder;
